import type { IconSvgObject } from './types';

const LinkCircleIcon: IconSvgObject = [
  ["path", { d: "M21.0017 12.0004C21.0017 16.9712 16.9716 21.0007 12.0001 21.0007C7.02869 21.0007 2.99854 16.9712 2.99854 12.0004C2.99854 7.0296 7.02869 3 12.0001 3", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M20.5537 3.46927L14.9902 9.0105M20.5537 3.46927C20.0585 2.97411 16.7223 3.02026 16.0171 3.03028M20.5537 3.46927C21.049 3.96442 21.0028 7.30005 20.9928 8.00523", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default LinkCircleIcon;
